import { Badge, BadgeProps } from '@mui/material';

export const SORT_PRIORITY_BADGE_TESTID = 'sort-priority-badge';

/**
 * `baseBadge` override for the DataGrid. The grid renders this slot for the sort
 * priority indicator and for the column filter counter; only the sort icon asks
 * for `overlap="circular"`, so that is what tags the badge for tests.
 */
const SortPriorityBadge = ({ overlap, ...props }: BadgeProps) => (
  <Badge
    overlap={overlap}
    {...props}
    {...(overlap === 'circular' && {
      'data-testid': SORT_PRIORITY_BADGE_TESTID,
    })}
  />
);

export default SortPriorityBadge;
